import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import { useIntl } from "react-intl";
import { includes } from "lodash";

export function useWriterBillingLastMonthsGridColumns(
    keys: string[]
): Array<SimpleEntityGridColumn> {
    const { formatMessage } = useIntl();

    const defaultKeys = ["writer", "id"];
    const months: any = [];
    keys.forEach((key) => {
        if (!includes(defaultKeys, key)) {
            months.push({
                field: key.toLowerCase(),
                headerName: `${formatMessage({ id: `content.grid.col.${key.toLowerCase()}` })}`,
                valueFormatter: ({ data }: any) => (data[key] ? data[key] : 0),
                filter: "agNumberColumnFilter",
                cellClass: "number-cell",
                minWidth: 70,
                maxWidth: 70,
            });
        }
    });

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "writer",
            headerName: formatMessage({ id: "content.grid.col.writer" }),
            pinned: "left",
        },
        {
            headerName: formatMessage({ id: "report.grid.col.months" }),
            children: [...months],
        },
    ];

    return gridColumns;
}
